<main id="contact-v2">
  <app-nav-bar-v2 [darkNav]="true"></app-nav-bar-v2>
  <app-contact-v2></app-contact-v2>
  <app-footer-v2></app-footer-v2>
</main>
